/**
 * Forecasting-page hook. Reads the persisted SARIMA projection + live
 * monthly actuals from `GET /forecast`. Keyed on (metric, historyMonths)
 * so a metric toggle swaps the series without refetching the other.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { ForecastMetric, ForecastResponse } from '@/types/forecast';

const STALE_MS = 60_000;

export function useForecast(
  metric: ForecastMetric,
  historyMonths = 36,
): UseQueryResult<ForecastResponse, Error> {
  return useQuery<ForecastResponse, Error>({
    queryKey: ['forecast', metric, historyMonths],
    queryFn: async () => {
      const { data } = await api.get<ForecastResponse>('/forecast', {
        params: { metric, history_months: historyMonths },
      });
      return data;
    },
    staleTime: STALE_MS,
  });
}
